import script from "./AsideMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./AsideMenu.vue?vue&type=script&lang=ts&setup=true"

import "./AsideMenu.vue?vue&type=style&index=0&id=c441af40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c441af40"]])

export default __exports__